export default function Features() {
  const mainFeature = {
    title: 'Trust & Safety First',
    description: 'Every member is verified with ratings and trust scores. Our community guidelines and reporting system ensure safe, reliable exchanges for everyone.',
    image: 'https://public.readdy.ai/ai/img_res/8eef8197350a11aa5fdf7801a0d6d38e.jpg'
  };

  const smallFeatures = [
    {
      title: 'Location-Based Matching',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20map%20with%20location%20pins%20and%20nearby%20items%2C%20clean%20interface%20design%2C%20teal%20and%20white%20color%20scheme%2C%20minimalist%20app%20mockup%2C%20location%20services%20visualization%2C%20user-friendly%20mobile%20experience%2C%20bright%20background&width=400&height=500&seq=feature-location-001&orientation=portrait'
    },
    {
      title: 'In-App Messaging',
      image: 'https://readdy.ai/api/search-image?query=Clean%20chat%20interface%20on%20mobile%20phone%20showing%20friendly%20conversation%20bubbles%2C%20modern%20messaging%20app%20design%2C%20teal%20accent%20colors%2C%20simple%20and%20intuitive%20UI%2C%20communication%20between%20users%2C%20safe%20messaging%20platform%2C%20bright%20minimal%20background&width=400&height=500&seq=feature-chat-001&orientation=portrait'
    },
    {
      title: 'Impact Tracking',
      image: 'https://readdy.ai/api/search-image?query=Dashboard%20showing%20environmental%20impact%20statistics%20with%20green%20leaf%20icons%2C%20CO2%20savings%20graph%2C%20sustainability%20metrics%20visualization%2C%20eco-friendly%20data%20display%2C%20clean%20modern%20interface%2C%20teal%20and%20green%20color%20palette%2C%20positive%20environmental%20impact&width=400&height=500&seq=feature-impact-001&orientation=portrait'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-3">
            <h2 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 leading-tight">
              Built for Community,<br />Designed for Impact
            </h2>
          </div>
          <div className="lg:col-span-2 flex items-center">
            <p className="text-lg text-gray-600 leading-relaxed">
              Our platform combines powerful features with a simple, intuitive design to make swapping easy, safe, and rewarding for everyone.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-2 bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
            <div className="h-64 overflow-hidden">
              <img
                src={mainFeature.image}
                alt={mainFeature.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{mainFeature.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{mainFeature.description}</p>
              <a href="#" className="inline-flex items-center gap-2 text-teal-600 font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap">
                Explore
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {smallFeatures.map((feature, index) => (
            <div key={index} className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer">
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{feature.title}</h3>
              </div>
              <div className="h-80 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
